export default {
  'timeSelect.lastDay': 'Ngày hôm trước',
  'timeSelect.last7Day': '7 ngày trước',
  'timeSelect.lastMonth': 'Tháng trước',
  'timeSelect.thisMonth': 'Tháng này',
  'timeSelect.userDefined': 'Chọn khoản thời gian',
  'timeSelect.SelectAll': 'Select All',
  'timeSelect.DeselectAll': 'Deselect All',
};
